import { gql } from "@apollo/client"
import {
  ALL_VEHICLE_LIST_FRAG,
  VEHICLE_DETAILS_FRAG,
  VEHICLE_DRIVER_FRAG,
  VEHICLE_LIST_FRAG,
  VEHICLE_OWNER_FRAG,
} from "./vehicle.fragments.gql"

// Queries
const VEHICLE_LIST = gql`
  query allVehicleList($query: String, $first: Int, $skip: Int) {
    allVehicles(query: $query, first: $first, skip: $skip) {
      ...VehicleListFrag
    }
  }
  ${VEHICLE_LIST_FRAG}
`

const VEHICLE_MASTER_LIST = gql`
  query vehicleMasterList(
    $query: String
    $first: Int
    $skip: Int
    $departmentId: ID
  ) {
    vehicleList(
      query: $query
      first: $first
      skip: $skip
      departmentId: $departmentId
    ) {
      ...VehicleListFrag
    }
  }
  ${VEHICLE_LIST_FRAG}
`
const VEHICLE_DETAILS = gql`
  query vehicleDetailsQuery($id: ID!) {
    vehicleDetails(vehicleId: $id) {
      ...VehicleDetailsFrag
    }
  }
  ${VEHICLE_DETAILS_FRAG}
`

const VEHICLE_OWNER_DETAILS = gql`
  query vehicleOwnerDetailsQuery($id: Int) {
    userDetails(userId: $id) {
      ...VehicleOwnerFrag
    }
  }
  ${VEHICLE_OWNER_FRAG}
`
const VEHICLE_DRIVER_DETAILS = gql`
  query vehicleDriverDetailsQuery($id: Int) {
    userDetails(userId: $id) {
      ...VehicleDriverFrag
    }
  }
  ${VEHICLE_DRIVER_FRAG}
`

export const ALL_VEHICLES_LIST = gql`
  query AllVehiclesList(
    $query: String
    $first: Int
    $skip: Int
    $filter: AllVehicleFilterInput
  ) {
    allVehiclesDetail(
      query: $query
      first: $first
      skip: $skip
      filter: $filter
    ) {
      ...AllVehicleListFrag
    }
  }
  ${ALL_VEHICLE_LIST_FRAG}
`

export const SUMMARY_ALL_VEHICLE = gql`
  query AllVehiclesSummary(
    $departmentId: ID!
    $date: Date
    $distributionCenterId: ID
  ) {
    summaryAllVehicle(
      departmentId: $departmentId
      date: $date
      distributionCenterId: $distributionCenterId
    ) {
      totalVehicles
      usableVehicles
      unusableVehicles
      availableVehicles
      unavailableVehicles
      plannedVehicles
      unplannedVehicles
      breakdownVehicles
      onleaveVehicles
      archivedVehicles
    }
  }
`
export {
  VEHICLE_DRIVER_DETAILS,
  VEHICLE_OWNER_DETAILS,
  VEHICLE_DETAILS,
  VEHICLE_LIST,
  VEHICLE_MASTER_LIST,
}
